import type { DocumentationFile } from '@si/types';
import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  documentationFileId: string;
}

export function useDeleteInstallationImg() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, documentationFileId }: Params) =>
      del({
        url: `/projects/${projectId}/documentation-files/${documentationFileId}`,
      }),
    onSuccess: (_, { projectId, documentationFileId }) => {
      const queryKey = queryKeys.getDocumentationFiles(projectId);
      const cache = queryClient.getQueryData<{
        documentationFiles: DocumentationFile[];
      }>(queryKey);

      if (cache) {
        queryClient.setQueryData(queryKey, {
          documentationFiles: cache.documentationFiles.filter(
            ({ documentationFileId: id }) => id.toString() !== documentationFileId
          ),
        });
      }
    },
  });

  const deleteDocumentationFile = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteDocumentationFile,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
